import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
} from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const FaqPage = () => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <section className="faq-section">
        <Container>
          <div className="section-title">
            <h2 className="text-center">Frequently Asked Questions</h2>
          </div>
          <div className="faq-wrapper">
            {/* 📦 Packaging Solutions */}
            <h3 className="faq-category-heading">📦 Packaging Solutions</h3>

            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                1. What type of packaging solutions do Packaging Vendors offer?
              </AccordionSummary>
              <AccordionDetails>
                Packaging Vendors offer a wide range of packaging options for
                different cuisines and dishes, including containers, boxes,
                wraps, cups, cutlery, and bags. Both regular and sustainable
                packaging options are available.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                2. What is sustainable packaging and how is it different?
              </AccordionSummary>
              <AccordionDetails>
                Sustainable packaging is eco-friendly and made from recyclable,
                biodegradable, or compostable materials. It helps reduce
                environmental impact while maintaining food safety and quality.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                3. How many packaging vendors are available on the platform?
              </AccordionSummary>
              <AccordionDetails>
                Currently, there are 8 packaging vendors on the platform, with 5
                of them offering sustainable packaging solutions.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel4"}
              onChange={handleChange("panel4")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                4. Can I choose packaging based on my cuisine or dish type?
              </AccordionSummary>
              <AccordionDetails>
                Yes, the platform allows you to raise queries and filter
                packaging solutions based on cuisine or specific dish
                requirements.
              </AccordionDetails>
            </Accordion>

            {/* 🛒 Ordering Process */}
            <h3 className="faq-category-heading">🛒 Ordering Process</h3>

            <Accordion
              expanded={expanded === "panel5"}
              onChange={handleChange("panel5")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                5. How can I order packaging ?
              </AccordionSummary>
              <AccordionDetails>
                You can browse available packaging options on the platform,
                compare vendors, and raise an order or enquiry through the
                website. The packaging vendor will contact you within 2 days of
                raising the enquiry.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel6"}
              onChange={handleChange("panel6")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                6. Can I place bulk orders?
              </AccordionSummary>
              <AccordionDetails>
                Yes, bulk orders are supported. You can specify quantities
                during the enquiry or order process.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel7"}
              onChange={handleChange("panel7")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                7. Is there a minimum order quantity (MOQ)?
              </AccordionSummary>
              <AccordionDetails>
                Minimum order quantities vary by vendor and product type. You
                can view this on each product’s detail page.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel8"}
              onChange={handleChange("panel8")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                8. Can I request samples before placing a full order?
              </AccordionSummary>
              <AccordionDetails>
                Yes, some vendors may allow sample requests for bulk orders.
                Please mention this while raising your enquiry or discuss it
                during the vendor's follow-up call.
              </AccordionDetails>
            </Accordion>

            {/* 🚚 Delivery & Logistics */}
            <h3 className="faq-category-heading">🚚 Delivery & Logistics</h3>

            <Accordion
              expanded={expanded === "panel9"}
              onChange={handleChange("panel9")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                9. What is the delivery turnaround time (TAT)?
              </AccordionSummary>
              <AccordionDetails>
                Delivery TAT depends on the vendor and your location, but it
                typically ranges from 5 to 7 business days.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel10"}
              onChange={handleChange("panel10")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                10. Can I track my packaging order?
              </AccordionSummary>
              <AccordionDetails>
                Yes, once your order is confirmed, you will receive tracking
                details via your registered phone number or email.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel11"}
              onChange={handleChange("panel11")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                11. Do vendors deliver pan-India?
              </AccordionSummary>
              <AccordionDetails>
                Most vendors offer pan-India delivery, but availability may
                vary. Please check the serviceable locations on the product or
                vendor page.
              </AccordionDetails>
            </Accordion>

            {/* 💰 Pricing & Payment */}
            <h3 className="faq-category-heading">💰 Pricing & Payment</h3>

            <Accordion
              expanded={expanded === "panel12"}
              onChange={handleChange("panel12")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                12. How is pricing determined for packaging products?
              </AccordionSummary>
              <AccordionDetails>
                Pricing is set by each vendor and may vary depending on
                material, quantity, and customization. Bulk discounts may apply.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel13"}
              onChange={handleChange("panel13")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                13. Can I compare prices between vendors?
              </AccordionSummary>
              <AccordionDetails>
                Yes, you can compare packaging solutions across vendors based on
                features, sustainability, pricing, and delivery TAT.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel14"}
              onChange={handleChange("panel14")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                14. What are the available payment options?
              </AccordionSummary>
              <AccordionDetails>
                Payments can be made via UPI, net banking, credit/debit cards,
                or wallets.
              </AccordionDetails>
            </Accordion>

            {/* 🛠️ Support & Customization */}
            <h3 className="faq-category-heading">🛠️ Support & Customization</h3>

            <Accordion
              expanded={expanded === "panel15"}
              onChange={handleChange("panel15")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                15. Can I customize packaging with my restaurant's branding?
              </AccordionSummary>
              <AccordionDetails>
                Yes, several vendors offer customization options including logo
                printing and custom sizes. You can request this while raising a
                query.
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel16"}
              onChange={handleChange("panel16")}
            >
              <AccordionSummary
                expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
              >
                16. Whom do I contact if I face an issue with my order?
              </AccordionSummary>
              <AccordionDetails>
                You can reach out to our support team via the platform or email
                us directly at{" "}
                <Link
                  to="mailto:partnersupport@swiggy.in"
                  className="text-orange"
                >
                  partnersupport@swiggy.in
                </Link>
                .
              </AccordionDetails>
            </Accordion>

            <div className="contact-info text-center">
              <p className="text-low-emphasis">
                Still got a question? You can email us at{" "}
                <Link
                  to={"mailto:partnersupport@swiggy.in"}
                  className="text-orange"
                >
                  partnersupport@swiggy.in
                </Link>
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default FaqPage;
